import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '..'
import { GetUseReasonDto } from '../../../../dataAccess/webApi/dto/useReasonDto'
import { 
  ParentInfoType, 
  ChildReservationInfoType, 
  UsageDatetimeType, 
  ShowMessage,
  FacilityInfoType,
  CommonInput
} from '../../reservation'

// TODO: common/reservationに移動する
export interface IsCertificateUseReasonViewFlags {
  irregularFlag: boolean
  emgFlag: boolean
  refreshFlag: boolean
}

export interface FacilityReserveEntry {
  reservationNo?: string
  showMessages: ShowMessage[]
  useReasonCategory: string | null
  useReasonDetailCategory: string | null
  useReasonDetailDescription: string | null
  isUseReasonCategoryHidden: boolean

  /** 利用日時 */
  usageDatetimes: UsageDatetimeType[]

  /** 施設情報 */
  facility: FacilityInfoType

  /** 保護者情報 */
  parentInfo?: ParentInfoType
  
  /** お子様さま情報 + お子様別予約情報 */
  childInfoList: ChildReservationInfoType[]
  
  /** お子様共通予約情報 */
  commonInput?: CommonInput

  /** 利用目的マスタ情報 */
  useReason?: GetUseReasonDto
  isCertificateUseReasonViewFlags: IsCertificateUseReasonViewFlags

  /** 利用同意事項同意 */
  consentCheck?: string

  /** 隔離フラグ */
  isolationFlag?: Boolean | null
}

interface FacilityReserveState {
  entry?: FacilityReserveEntry
  updateDatetime?: string
}

const initialState: FacilityReserveState = {}

export const facilityReserveSlice = createSlice({
  name: 'facilityReserve',
  initialState,
  reducers: {
    setFacilityReserve: (state, action: PayloadAction<FacilityReserveEntry>) => {
      state.entry = action.payload
    },
    setReserveModifyUpdateDatetime: (state, action: PayloadAction<string>) => {
      state.updateDatetime = action.payload
    },
    clearFacilityReserve: (state) => {
      delete state.entry
      delete state.updateDatetime
    },
  },
})

export const { setFacilityReserve, setReserveModifyUpdateDatetime, clearFacilityReserve } = facilityReserveSlice.actions
export const selectFacilityReserveEntry = (state: RootState) => state.facilityReserve.entry
export const selectReserveModifyUpdateDatetime = (state: RootState) => state.facilityReserve.updateDatetime
export default facilityReserveSlice.reducer